import React from 'react';
import bemHelper from 'react-bem-helper';
import cookie from '../../../../lib/cookie';
import '../../../../lib/find';

import { replaceStyleImageUri } from '../../utils';
import * as constants from '../../constants';
import Price from '../../../../subComponents/price';
import ourProductsAnalytics from '../../analytics/our-products';
import './styles.scss';

const bem = bemHelper({ prefix: 'toga-', name: 'top-product' });

const SalePrices = ({ prices: { priceShape, salePriceShape } }) => {
  return (
    <div {...bem('price-group', 'sale')}>
      <Price price={priceShape} isPlaceholder={true}/>
      <Price price={salePriceShape} onSale={true}/>
    </div>);
};

class Product extends React.Component {

  static propTypes = {
    product: React.PropTypes.shape({
      image: React.PropTypes.string,
      name: React.PropTypes.string,
      prices: React.PropTypes.array,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      currency: null,
      price: null,
    };

    this.getPrice = this.getPrice.bind(this);
    this.getPriceShape = this.getPriceShape.bind(this);
  }

  componentWillMount() {
    const currency = cookie.get('currency') || 'GBP';
    this.setState({ currency });
  }

  componentDidMount() {
    if (!this.refs.product) {
      return;
    }
    const clientWidth = this.refs.product.clientWidth;
    this.setState({ height: clientWidth });
  }

  clickAnchorHandler(idProduct) { //eslint-disable-line
    ourProductsAnalytics.registryViewProduct(idProduct);
  }

  getPrice(prices) {
    return prices ? prices.find((elem) => {
      return elem.currency === this.state.currency;
    }).amount : 0;
  }

  getPriceShape(price) {
    return {
      amount: price,
      currency: this.state.currency
    };
  }

  render() {
    const { product, classes, partnerName } = this.props;

    // price info
    const price = product.prices && this.getPrice(product.prices);
    const priceShape = price && this.getPriceShape(price);

    // on sale info
    const { onSale, onSaleInfo } = product;
    const salePrice = onSaleInfo && onSaleInfo.prices && this.getPrice(onSaleInfo.prices);
    const salePriceShape = salePrice && this.getPriceShape(salePrice);

    return (
      <div {...bem(null, classes)}
           ref="product"
           style={{ backgroundImage: `url(${replaceStyleImageUri(product.image, constants.IMAGE_SIZE_NORMAL)})` }}>
        {product.new && !product.onSale && <span {...bem('new')}>new</span>}
        {onSale && onSaleInfo && <span {...bem('sale')}>{onSaleInfo.discount}% off</span>}
        <a onClick={this.clickAnchorHandler.bind(this, product.productId)}
           href={product.link}>
          <span className="sr-only">This is a product from {partnerName} named {product.name}</span>
          <div {...bem('layer')}>
            <span {...bem('layer-name')}>{product.name}</span>
            {onSale ?
              <SalePrices prices={{ priceShape, salePriceShape }}/>
              :
              <Price price={priceShape}/>
            }
          </div>
        </a>
      </div>
    );
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/components/storefront/components/Product/Product.js